var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-insure-info-detail',{staticClass:"pt-insure-info-detail__withData",attrs:{"insureInfoDetail":_vm.insureInfoDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }